<template>
    <dialog
        ref="dialogRef"
        class="relative w-[calc(100%-3rem)] max-w-screen-xl rounded-xl px-10 py-6 font-inter backdrop:bg-ds-primary-500/50"
        @close="isOpen = false"
    >
        <button
            class="absolute right-8 top-4 text-3xl shadow-none hover:opacity-50"
            type="button"
            @click="isOpen = false"
        >
            &times;
        </button>
        <EmdMergeFlow
            :closeAndUnmount="close"
            :fullFileFormData
            :similarEmds
            :submitFormWith
        />
    </dialog>
</template>

<script setup lang="ts">
import type { SimilarFilesProps } from '@/company-portal/add-view-file';
import EmdMergeFlow from '@/components/Views/Company/EmdMergeFlow.vue';
import { ref, watch } from 'vue';

defineProps<SimilarFilesProps>();

const isOpen = defineModel<boolean>('open', { required: true });

const dialogRef = ref<HTMLDialogElement>();
const close = () => (isOpen.value = false);

watch(isOpen, open => {
    if (open) {
        dialogRef.value?.showModal();
    } else if (dialogRef.value?.open) {
        dialogRef.value.close();
    }
});
</script>
